export const LINEAR_3_LAYOUT = {
    id: 'linear-3',
    family: 'triad',
    cards: 3,
    description: 'Triade lineare per timeline semplici, daily spread e letture a progressione chiara.',
    supports_focus_overlay: false,
    variants: [
        {
            id: 'portrait',
            points: [
                { x: 16, y: 54, z: 1 },
                { x: 50, y: 50, z: 1 },
                { x: 84, y: 54, z: 1 },
            ],
        },
        {
            id: 'compact',
            points: [
                { x: 18, y: 56, z: 1 },
                { x: 50, y: 56, z: 1 },
                { x: 82, y: 56, z: 1 },
            ],
        },
        {
            id: 'tablet',
            points: [
                { x: 20, y: 50, z: 1 },
                { x: 50, y: 48, z: 1 },
                { x: 80, y: 50, z: 1 },
            ],
        },
    ],
};
//# sourceMappingURL=linear-3.js.map